import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useUserRole } from '../hooks/useUserRole.js';

/** Where a non-member lands instead of a band admin page (ENG-500). */
export const publicSongListPath = (bandid) => `/public/bands/${bandid}/songlist`;
export const bandPagePath = (bandid) => `/performers/${bandid}`;

/**
 * Route guard for a band's admin pages (ENG-500): the song list, Edit Tags,
 * Add Song, import and events. Those pages render their edit controls for
 * anyone and call member-only routes on load, so a fan who opened one saw
 * controls that could only fail (with a 403 that used to log them out).
 *
 * The viewer's role comes from `viewer_role` on `GET /bands/{id}`, through
 * useUserRole. Nothing of the page mounts until it is known, so a
 * non-member never makes the page's member-only requests. Only members get
 * through; moderators, followers, everyone else and signed-out visitors are
 * sent to `redirectTo(bandid)`. A failure to read the role is treated the
 * same way, so the page fails closed.
 *
 * @param {{ children: React.ReactNode, redirectTo?: (bandid: string) => string }} props
 */
const RequireBandMember = ({ children, redirectTo = publicSongListPath }) => {
  const { bandid } = useParams();
  const { isMember, isLoading } = useUserRole(bandid);

  if (isLoading) return null;
  if (!isMember) return <Navigate to={redirectTo(bandid)} replace />;
  return children;
};

export default RequireBandMember;
